import { createApp } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'
import App from './App.vue'
import Routes from '@/routes/Routes'
//import {Tabs, Tab} from 'vue3-tabs-component';

const router = createRouter({
    history: createWebHashHistory(),
    routes: Routes,
})

const app = createApp(App)
//app.component('tabs', Tabs)
//app.component('tab', Tab)
app.use(router)
app.mount('#app')
